import { TextField } from "@fluentui/react";
import React, { FC, Fragment, useState } from "react";
import moment from "moment";
import { LineHandling } from "../../models";
import EtaModal from "./EtaModal";
import { FaRegCalendar, FaRegClock } from "react-icons/fa";
import { DefaultButton } from "@fluentui/react";

type Props = {
  lineHandling: LineHandling;
  isEditETAAllowed: boolean;
  onSuccess(value: string): void;
};

const EtaButton: FC<Props> = (props: Props) => {
  const [showModal, setShowModal] = useState(false);
  let result = <></>;

  const iconProps = { iconName: "DateTime" };

  switch (props.lineHandling.status) {
    case 0:
      result = (
        <>
        <span className="eta-section">
        <FaRegCalendar className="eta-section-icon"/>
          {props.lineHandling.eta ? moment
            .utc(props.lineHandling.eta)
            .local()
            .format("ll"):"-"}
            </span>
        <span className="eta-section2">
            <FaRegClock className="eta-section-icon"/>
            {props.lineHandling.eta ? moment
            .utc(props.lineHandling.eta)
            .local()
            .format("HH:mm"):"-"}
            </span>
        </>
      );
      break;
    case 3:
      result = (
        <>
        <span className="eta-section">
        <FaRegCalendar className="eta-section-icon"/>
          {props.lineHandling.departureDate ? moment
            .utc(props.lineHandling.departureDate)
            .local()
            .format("ll"):"-"}
            </span>
            <span className="eta-section2">
            <FaRegClock className="eta-section-icon"/>
            {props.lineHandling.departureDate ? moment
            .utc(props.lineHandling.departureDate)
            .local()
            .format("HH:mm"):"-"}
            </span>
        </>
      );
      break;
    case 4:
      result = (
        <>
        <span className="eta-section">
        <FaRegCalendar className="eta-section-icon"/>
          {props.lineHandling.approvalDate ? moment
            .utc(props.lineHandling.approvalDate)
            .local()
            .format("ll"):"-"}
            </span>
            <span className="eta-section2">
            <FaRegClock className="eta-section-icon"/>
            {props.lineHandling.approvalDate ? moment
            .utc(props.lineHandling.approvalDate)
            .local()
            .format("HH:mm"):"-"}
            </span>
        </>
      );
      break;
    case 6:
      result = (
        <>
          <span className="eta-section">
            <FaRegCalendar className="eta-section-icon"/>
            {props.lineHandling.tenderedDate ? moment
              .utc(props.lineHandling.tenderedDate)
              .local()
              .format("ll"):"-"}
          </span>
          <span className="eta-section2">
            <FaRegClock className="eta-section-icon"/>
            {props.lineHandling.tenderedDate ? moment
            .utc(props.lineHandling.tenderedDate)
            .local()
            .format("HH:mm"):"-"}
          </span>
        </>
      );
      break;
    default:
      result = (
        <>
          <span className="eta-section">
            <FaRegCalendar className="eta-section-icon"/>
              {props.lineHandling.arrivalDate ? moment
                .utc(props.lineHandling.arrivalDate)
                .local()
                .format("ll"):"-"}
            </span>
            <span className="eta-section2">
              <FaRegClock className="eta-section-icon"/>
              {props.lineHandling.arrivalDate ? moment
              .utc(props.lineHandling.arrivalDate)
              .local()
              .format("HH:mm"):"-"}
            </span>
        </>
      );
      break;
  }

  return (
    <Fragment>
      {showModal && (
        <EtaModal
          {...props}
          onSuccess={(value: string) => {
            props.onSuccess(value);
            setShowModal(false);
          }}
          onClose={() => setShowModal(false)}
          />
          )}
          <div className="eta-row">
            {result}
            <DefaultButton
              className="find-eta-btn"
              onClick={()=>setShowModal(true)}
            >
              <img src={"/misc/globe_search.svg"}/>
            </DefaultButton>
          </div>
    </Fragment>
  );
};

export default EtaButton;
